// Clients testimonials component
import React from "react";
import '../../styles/homepage/ClientTestimonials.css';

function ClientTestimonials(){

    return(
        <div className="client-testimonials">
            <h2>Check Our Clients Feedback</h2>
            <div  className="client-testimonials-content">
                <div className="client-testimonial-card">
                    <p><span>"</span>My experience with the system is that it has helped our cooperative to have accuracy on data tracking, we now have the ability to make amendments and leave trail. Timely reports based on entries are made enabling us to analyze data and enable accurate keeping of records. It is also a fast accounting system as all our sales are monitored.<span>"</span></p>
                    <h5>Deborah Syatata Mpande</h5>
                    <h6>PANJIRA MULTI-PURPOSE COOPERATIVE SOCIETY LIMITED</h6>
                </div>
                <div className="client-testimonial-card">
                    <p><span>"</span>Kindertech ERP systems have truly revolutionized how we handle CRM and manage our payment flow. This software's seamless integration has significantly improved our customer relationship management, making data centralization and client interactions smoother. Its robust financial management features have given us invaluable insights into our cash flow, empowering us to make informed decisions. For SMEs seeking efficiency and growth, Kindertech is a must-have tool that simplifies operations and has become our go-to software.<span>"</span></p>
                    <h5>David Chitundu</h5>
                    <h6>FitCity Zambia</h6>
                </div>
            </div>
        </div>
    )
};

export default ClientTestimonials;
